<script setup lang="ts">
import { Search } from 'lucide-vue-next';
import ProjectCard from './ProjectCard.vue';

defineProps<{
    projects: any[];
}>();

const emit = defineEmits(['open', 'reset-filters']);
</script>

<template>
    <div v-if="projects.length === 0" class="h-full flex flex-col items-center justify-center space-y-6 max-w-sm mx-auto opacity-40 grayscale group cursor-wait">
        <div class="w-24 h-24 bg-slate-900 rounded-[2rem] border border-slate-800 flex items-center justify-center shadow-2xl relative overflow-hidden">
            <Search class="w-10 h-10 text-slate-700 transition-all duration-1000 group-hover:scale-150 group-hover:rotate-12" />
        </div>
        <div class="space-y-2 text-center">
            <h3 class="text-xl font-black text-white tracking-widest uppercase italic">Aucun résultat</h3>
            <p class="text-xs text-slate-500 leading-relaxed font-bold uppercase tracking-tighter">Votre recherche n'a retourné aucun projet correspondant aux critères spécifiés</p>
        </div>
        <button @click="$emit('reset-filters')" class="text-[10px] font-black text-blue-500 uppercase tracking-[0.2em] hover:text-blue-400 underline underline-offset-8 transition-colors">Réinitialiser les filtres</button>
    </div>

    <div v-else class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-8 relative z-10 transition-all duration-500" role="list">
        <ProjectCard 
            v-for="project in projects" 
            :key="project.id" 
            :project="project" 
            @open="$emit('open', $event)"
        />
    </div>
</template>
